import React from "react";

interface Props {
    children: React.ReactNode;
    customClass?: string;
    columnNumber?: number;
    centerAlignment?: boolean;
}

const LayoutContainer = (props: Props) => {
    const { children, customClass, columnNumber, centerAlignment } = props;
    return (
        <div className={`py-5 ${customClass ?? ""}`}>
            <div className="container">
                <div className={`row ${centerAlignment ? "justify-content-center" : ""}`}>
                    <div className={`col-lg-${columnNumber ?? 12}`}>{children}</div>
                </div>
            </div>
        </div>
    );
};

export default LayoutContainer;
